<div class="d-inline-flex" [attr.title]="disabledMessage | messageTranslate">
  <app-button [label]="showText ? 'Estimate Meter Data' : undefined"
              [faIcon]="!showText ? 'wave-square' : undefined"
              [size]="size"
              [visual]="visual"
              [disabled]="disabled"
              [loading]="loading"
              [buttonNgClass]="buttonStyles"
              (buttonClick)="checkAndShowEstimateRangePicker()" />
</div>

<ng-template #estimateRangePicker let-modal>
  <form (ngSubmit)="estimateMeterData(detectedDataPeriodStr)">
    <div class="modal-header">
      <h4 class="modal-title">{{'Estimate Meter Data' | messageTranslate}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <p class="small text-body-secondary">{{'Timezone' | messageTranslate}}: {{timezone}}</p>
      <div>
        <app-date-time-range-select [formControl]="dateTimeRangeControl"
                                    [minDate]="earliestHistoryDateTime"
                                    [timezone]="timezone"
                                    [showTime]="showTime"/>
      </div>
      @if (detectedDataPeriodStr) {
        <div>
          <span class="text-danger small">{{'Detected different data period, proceed?' | messageTranslate:{detectedDataPeriod: formatDataPeriod(detectedDataPeriodStr)} }}</span>
        </div>
      }
    </div>
    <div class="modal-footer">
      <app-button type="submit"
                  visual="primary"
                  size="sm"
                  [label]="!detectedDataPeriodStr ? 'Estimate' : 'Yes'"
                  [loading]="estimating"
                  [disabled]="!dateTimeRangeControl.valid"/>
    </div>
  </form>
</ng-template>

<ng-template #estimatedMeterData let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{'Estimated Meter Data' | messageTranslate}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <app-ace-table [columns]="meterDataGapColumns"
                   [rows]="estimatedMeterDataRanges"
                   [showPageLimitControl]="false"
                   [messages]="{emptyMessage: noMeterGapsEstimatedMessage}"/>
  </div>
  <div class="modal-footer">
    <button class="btn btn-sm btn-primary" (click)="modal.dismiss()">{{'OK' | messageTranslate}}</button>
  </div>
</ng-template>


<ng-template #headerTemplate let-column="column" >
  {{column.name | messageTranslate}}
</ng-template>

<ng-template #cellTemplate let-value="value">
  {{value}}
</ng-template>

<ng-template #translatedCellTemplate let-value="value">
  {{value | messageTranslate}}
</ng-template>
